import { render, staticRenderFns } from "./ViewSuppliedItem.vue?vue&type=template&id=0dbf1c5d"
import script from "./ViewSuppliedItem.vue?vue&type=script&lang=js"
export * from "./ViewSuppliedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports